module.exports = __webpack_public_path__ + "img/icon_MnO4- .1f529363.png";